import React, { forwardRef } from 'react';
import styles from './styledComponents.module.css';

const cx = (...classes: (string | undefined)[]) =>
  classes.filter(Boolean).join(' ');

type DivProps = React.ComponentPropsWithoutRef<'div'>;

export const SubscriptionDisclaimerDiv = forwardRef<HTMLDivElement, DivProps>(
  ({ className, ...rest }, ref) => (
    <div
      ref={ref}
      className={cx(styles.subscriptionDisclaimerDiv, className)}
      {...rest}
    />
  ),
);
SubscriptionDisclaimerDiv.displayName = 'SubscriptionDisclaimerDiv';

export const PlantTrees = forwardRef<HTMLDivElement, DivProps>(
  ({ className, ...rest }, ref) => (
    <div ref={ref} className={cx(styles.plantTrees, className)} {...rest} />
  ),
);
PlantTrees.displayName = 'PlantTrees';
